import { CircularProgress, Theme } from '@material-ui/core';
import { Form, FormikProvider } from 'formik';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import styled, { css } from 'styled-components';
import { useTrackLoadboardEvent } from '../../core/LoadboardAnalytics';
import { useNotificationsSettingsForm } from '../../core/notifications-settings/data/NotificationsSettingsFormState';
import { NotificationSettingsForm } from './NotificationSettingsForm';

const Container = styled.div(
  ({ theme }: { theme: Theme }) => css`
    padding: ${theme.spacing(1, 1, 11, 1)};

    /* Allow mobile users to tap full width checkbox*/
    & .MuiFormControl-root {
      width: 100%;
    }
  `,
);

const Styled1 = styled.div`
  display: flex;
  justify-content: center;
`;

export function PostingNotificationsSettingsPage() {
  const form = useNotificationsSettingsForm();
  const { settingsForm, notificationSettings } = form;

  useTrackLoadboardEvent({ name: 'SLB: Notification settings opened' });

  useDocumentTitle('Loadboard Notifications');

  if (notificationSettings.error) {
    return (
      <Container>Something went wrong. Please refresh the page.</Container>
    );
  }

  return (
    <WebviewLayout>
      <FormikProvider value={settingsForm}>
        <Form>
          <Container>
            {!notificationSettings.data ? (
              <Styled1>
                <CircularProgress />
              </Styled1>
            ) : (
              <NotificationSettingsForm {...form} />
            )}
          </Container>
        </Form>
      </FormikProvider>
    </WebviewLayout>
  );
}
